export default __webpack_public_path__ + "static/online-brand-guideline-builder@2x-ef4a3be2e70e4d82dd3e5d0d4749c87a.png";